const FIRST_NUMBER = "FIRST_NUMBER"
const SECOND_NUMBER = "SECOND_NUMBER"
const OPERATOR = "OPERATOR"
const SUM_ANSWER = "SUM_ANSWER"
const SUBTRACT_ANSWER = "SUBTRACT_ANSWER"
const REVERSE_SUBTRACT_ANSWER = "REVERSE_SUBTRACT_ANSWER"
const USER_ANSWER = "USER_ANSWER"
const CLEAR_USER_ANSWER = "CLEAR_USER_ANSWER"
const CLEAR_PROBLEM = "CLEAR_PROBLEM"

const MEDIUM_SECOND_NUMBER = "MEDIUM_SECOND_NUMBER"
const HARD_FIRST_NUMBER = "HARD_FIRST_NUMBER"
const MULTIPLY_FIRST_NUMBER = "MULTIPLY_FIRST_NUMBER"
const MULTIPLY_SECOND_NUMBER = "MULTIPLY_SECOND_NUMBER"
const MULTIPLY_OPERATOR = "MULTIPLY_OPERATOR"
const MULTIPLY_ANSWER = "MULTIPLY_ANSWER"

const DIVIDE_FIRST_NUMBER = "DIVIDE_FIRST_NUMBER"
const DIVIDE_SECOND_NUMBER = "DIVIDE_SECOND_NUMBER"
const DIVIDE_OPERATOR = "DIVIDE_OPERATOR"
const DIVIDE_ANSWER = "DIVIDE_ANSWER"

const INCREASE_SCORE = "INCREASE_SCORE"
const REDUCE_SCORE = "REDUCE_SCORE"

const SUCCESS_PHRASE = "SUCCESS_PHRASE"

export {
    FIRST_NUMBER,
    SECOND_NUMBER,
    OPERATOR,
    SUM_ANSWER,
    SUBTRACT_ANSWER,
    REVERSE_SUBTRACT_ANSWER,
    USER_ANSWER,
    CLEAR_USER_ANSWER,
    CLEAR_PROBLEM,

    MEDIUM_SECOND_NUMBER,
    HARD_FIRST_NUMBER,
    MULTIPLY_FIRST_NUMBER,
    MULTIPLY_SECOND_NUMBER,
    MULTIPLY_OPERATOR,
    MULTIPLY_ANSWER,

    DIVIDE_FIRST_NUMBER,
    DIVIDE_SECOND_NUMBER,
    DIVIDE_OPERATOR,
    DIVIDE_ANSWER,

    INCREASE_SCORE,
    REDUCE_SCORE,

    SUCCESS_PHRASE
}